import cookieService from "intranet/features/users/cookieService";
import {
  completeAuthCheck,
  getMe,
  reset,
} from "intranet/features/users/usersSlice";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import useURL from "shared/welda/hooks/useURL";

const useUser = (createRoutes) => {
  const {
    client: reduxClient,
    user: reduxUser,
    isError: isUserSliceError,
    isLoading: isLoadingUser,
  } = useSelector((state) => state.users);

  const { i18n } = useTranslation();
  const { URLPrefix } = useURL();
  const dispatch = useDispatch();
  const hasreduxClient = !!reduxClient;
  const hasreduxUser = !!reduxUser;
  const pathname = window.location.pathname;
  const isLogoutPage =
    pathname === "/logout" ||
    pathname === `${URLPrefix}auth/logout`;

  // 1. Fetch the user if we only have a cookie
  useEffect(() => {
    if (isLogoutPage || hasreduxClient || hasreduxUser) {
      return;
    }

    const checkCookieAndGetMe = async () => {
      const isDev = process.env.REACT_APP_ENV === "development";
      // NOTE: In development mode, we need an extra cookie fetch before we can do getMebecause we have a separate server for the frontend
      if (isDev) {
        try {
          const checkCookieData = await cookieService.checkCookie();
          if (checkCookieData.success && checkCookieData.execGetMe) {
            dispatch(getMe());
          } else {
            dispatch(completeAuthCheck());
          }
        } catch {
          dispatch(completeAuthCheck());
        }
      } else {
        // NOTE: In production, we can directly fetch the user from the cookie, as the cookie is set on the first request
        dispatch(getMe());
      }
    };
    checkCookieAndGetMe();
  }, [
    hasreduxClient,
    hasreduxUser,
    reduxClient,
    isLogoutPage,
    dispatch,
  ]);

  // 3. Setup routes once we know loading is done
  useEffect(() => {
    if (!isLoadingUser) {
      createRoutes();
    }
  }, [isLoadingUser, reduxClient]);

  // 5. Reset the user if there is an error, but keep auth as "attempted"
  // so public pages (e.g. /hrf) can redirect to login instead of spinning forever.
  useEffect(() => {
    if (isUserSliceError) {
      dispatch(reset());
      dispatch(completeAuthCheck());
    }
  }, [isUserSliceError, dispatch]);

  return {};
};

export default useUser;
